import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const BillsandAppliedPayments = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalamount, setTotalAmount] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [supplier, setSupplier] = useState([]);
  const [supplierId, setSupplierId] = useState(0);

  console.log(enddate, startdate, "startdate and enddate");
  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [nemultiselect, setnemultiselect] = useState({
    TransactionType: [],
  });
  const [classicView, setClassicView] = useState(true);

  // const handleDropdownChange = (event) => {
  //   console.log(event, "check date event");
  //   setSelectReport(event?.value);
  //   console.log(event.target.value);
  //   if (event?.value == 1) {
  //     setStartDate("");
  //     setEndDate("");
  //   }
  // };

  const handleDropdownChange = (event) => {
    console.log(event, "check date event");
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
    setSelectReport(event?.value);
  };

  const handleSupplierChnage = (event) => {
    console.log(event, "eventevent");
    if (event != null) {
      setSupplierId(event.value);
    } else {
      setSupplierId(0);
    }
  };

  const paramObject = useParams();
  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/billandappliedpayment?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&supplierId=${supplierId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const data = res.data.ResponseData;
          setnemultiselect({
            TransactionType: [
              ...new Set(data?.map((item) => item?.TransactionType)),
            ],
          });
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            OpenBalance: el.OpenBalance ? Number(el.OpenBalance) : "",
            Amount: el.Amount ? Number(el.Amount) : "",
            ReceivingTxnId: el.ReceivingTxnId ? Number(el.ReceivingTxnId) : "",
            Vendor: el.Vendor ? el.Vendor : "",
            CreatedBy: el.CreatedBy ? el.CreatedBy : "",
            MemoDescription: el.MemoDescription ? el.MemoDescription : "",
            TransactionType: el.TransactionType ? el.TransactionType : "",
            CreateDate: el.CreateDate ? el.CreateDate : "",
            LastModified: el.LastModified ? el.LastModified : "",
            Split: el.Split ? el.Split : "",
            Account: el.Account ? el.Account : "",
            PaymentMethod: el.PaymentMethod ? el.PaymentMethod : "",
            Status: el.Status ? el.Status : "",
            Terms: el.Terms ? el.Terms : "",
            DueDate: el.DueDate ? (el.DueDate == "0" ? "" : el.DueDate) : "",
            Num: el.Num ? el.Num : "",
          }));
          setResponseData(FilterData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        const supplierOption = response.data.ResponseData.map((u) => ({
          label: `${u.CompanyName} (${u.FirstName} ${u.LastName})`,
          value: u.ID,
          quickbookid: u.QuickBookId,
          Balance: u.Balance,
        }));
        setSupplier(supplierOption);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const Classiccolumns = [
    {
      title: "Vendor Name",
      field: "Vendor",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Transaction Date",
      field: "Date",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.TransactionType || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

        span.addEventListener("click", (e) => {
          e.preventDefault();
          const type = data.TransactionType;
          const BillID = data.TxnId;
          let url = `/Expense/${BillID}`; // default

          if (type == "Bill Payment") {
            url = `/receiving-paybills/${BillID}`;
          } else if (type == "Bill" || type == "Vendor Credit") {
            url = `/receiving-receipt/${BillID}`;
          } else if (type == "Journal Entry") {
            url = `/journal-entry/${BillID}`;
          } else if (type == "Deposit") {
            url = `/bank-deposit/${BillID}`;
          }

          window.open(url, "_blank");
        });

        return span;
      },
    },
    {
      title: "Memo / Description",
      field: "MemoDescription",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Num",
      field: "NUM",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Open Balance",
      field: "OpenBalance",
      headerFilter: "input",
      // defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },

    {
      title: "Created Date",
      field: "CreateDate",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Last Modified",
      field: "LastModified",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Last Modified By",
      field: "LastModifiedBy",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
    {
      title: "Split",
      field: "Split",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Account",
      field: "Account",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Payment Method",
      field: "PaymentMethod",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Terms",
      field: "Terms",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
    {
      title: "Due Date",
      field: "DueDate",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
  ];

  const columns = useMemo(() => [
    // {
    //   header: "Txn Id",
    //   accessorKey: "TxnId",
    //   size: "110",
    //   filterFn: "contains",
    // },
    {
      header: "Vendor Name",
      accessorKey: "Vendor",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Transaction Date",
      accessorKey: "Date",
      size: "140",
      filterFn: "contains",
      Cell: ({ row }) => {
        const TransactionDate = moment(row.original.Date);
        if (TransactionDate.isValid()) {
          return TransactionDate.format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      size: "110",
      filterFn: "contains",
      filterSelectOptions: nemultiselect?.TransactionType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            // fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {
            const url =
              row.original?.ReceivingsType === "Bill Payment"
                ? `/receiving-paybills/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Bill" ||
                  row.original?.ReceivingsType === "Vendor Credit"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Expense"
                ? `/Expense/${row.original.TxnId}`
                : "#";

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Memo / Description",
      accessorKey: "MemoDescription",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        return row.original.Num == 0 ? "" : row.original.Num;
      },
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Amount = parseFloat(row?.original?.Amount);
        if (isNaN(Amount) || Amount === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {CurrencySymbols(
                Number(Amount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const OpenBalance = parseFloat(row?.original?.OpenBalance);
        if (isNaN(OpenBalance) || OpenBalance === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {CurrencySymbols(
                Number(OpenBalance),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreateDate",
      size: "140",
      filterFn: "contains",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreateDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "CreatedBy",
      accessorKey: "CreatedBy",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Modified Date",
      accessorKey: "LastModified",
      size: "140",
      filterFn: "contains",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModified;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Split",
      accessorKey: "Split",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Account Name",
      accessorKey: "Account",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "DueDate",
      accessorKey: "DueDate",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const DueDate = moment(row.original.DueDate);
        if (DueDate.isValid()) {
          return DueDate.format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const muiTableBodyCellProps = ({ row }) => {
    console.log("Row Props:", row.original);
    return {
      sx: {
        fontWeight:
          row.original?.TransactionType === "Bill Payment"
            ? "bold !important"
            : "normal",
      },
    };
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Bills and Applied Payments
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-6 form-label p-lg-medium">
                Supplier
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={supplier}
                    placeholder="All"
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={supplier?.find((option) => {
                      return option.value === supplierId;
                    })}
                    onChange={(event) => handleSupplierChnage(event)}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Bills and Applied Payments
                    </p>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={["Vendor"]}
                      Reportname={"Bills and Applied Payments"}
                      frozenRowvalue={0}
                      // layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Bills and Applied Payments"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={["Vendor"]}
                      enableExpandAll={true}
                      enableExpanding={true}
                      expanded={true}
                      enableRowSelection={false}
                      muiTableBodyCellProps={muiTableBodyCellProps}
                      columnsVisibility={{
                        OpenBalance: false,
                        CreateDate: false,
                        CreatedBy: false,
                        LastModified: false,
                        LastModifiedBy: false,
                        Split: false,
                        Account: false,
                        PaymentMethod: false,
                        Status: false,
                        Terms: false,
                        DueDate: false,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BillsandAppliedPayments;
